import { render, staticRenderFns } from "./SuccessAnimation.vue?vue&type=template&id=51844560&scoped=true"
import script from "./SuccessAnimation.vue?vue&type=script&lang=js"
export * from "./SuccessAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51844560",
  null
  
)

export default component.exports